import { useMemo } from "react";
import PropTypes from "prop-types";

import { action, palette } from "./palette";
import { shadows } from "./shadows";
import { overrides } from "./overrides";
import { typography } from "./typography";
import { customShadows } from "./custom-shadows";
import CssBaseline from "@mui/material/CssBaseline";
import {
  createTheme,
  ThemeProvider as MUIThemeProvider,
} from "@mui/material/styles";
import { components } from "@aws-amplify/ui-react";

// ----------------------------------------------------------------------

export default function ThemeProvider({ children }) {
  const memoizedValue = useMemo(
    () => ({
      palette: palette(),
      typography: {
        fontFamily: "RightGrotesk",
      },
      shadows: shadows(),
      customShadows: customShadows(),
      shape: { borderRadius: 8 },
      components: {
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              borderRadius: "30px !important",
            },
          },
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              borderRadius: "30px",
            },
          },
        },
      },
    }),
    []
  );

  const theme = createTheme(memoizedValue);

  theme.components = overrides(theme);

  return (
    <MUIThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MUIThemeProvider>
  );
}

ThemeProvider.propTypes = {
  children: PropTypes.node,
};
